import { FC } from 'react';
import { useDriver } from '../../services/driver';
import styles from './DriverGreeting.module.css';
import { useIntl } from 'react-intl';

interface DriverGreetingProps {}

export const DriverGreeting: FC<DriverGreetingProps> = () => {
  const { result } = useDriver();
  const { $t } = useIntl();

  return (
    <h2 className={styles.title}>
      {$t(
        { id: 'Greeting' },
        { name: `${result?.firstName ?? ''} ${result?.lastName ?? ''} 👋` }
      )}
    </h2>
  );
};
